export default "__VITE_ASSET__chftRR5H__"